import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';

import metadata from '../block.json';
import Edit from './Edit';
import './editor.scss';
import icons from './Const/icons';

registerBlockType(metadata, {
	icon: icons.sticky,

	// Build in Functions
	edit: Edit,

	save: () => <InnerBlocks.Content />
});